import { Slider, Stack, styled } from '@mui/material';
import { colors } from '@watter/shared-components';

import assetLoader from '../../assets/images/heater.png';

export const ListItemWrapper = styled(Stack)(({ theme }) => ({
    '&.wrapperItems': {
        background: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
    },
    '&.wrapper': {
        position: 'relative',
        background: theme.palette.mode === 'dark' ? colors.lightHead : colors.white,
        '& .blue_text': {
            color: colors.lightBlue,
            fontWeight: 700,
        },
        '& .MuiSvgIcon-root': {
            position: 'absolute',
            right: 0,
            fontSize: theme.spacing(11.375),
            zIndex: 0,
            color: theme.palette.mode === 'dark' ? colors.iconDarkBg : colors.iconLightBg,
            top: theme.spacing(1),
        },
    },
    '& .cstGraph': {
        background: 'transparent !important',
    },
}));
export const StyleWrapper = styled(Stack)(({ theme }) => ({
    '&.cstDashboard': {
        height: 'calc(100dvh - 136px)',
        '&.indexBodyLoader': {
            height: 'calc(100dvh - 127px)',
            [theme.breakpoints.down('sm')]: {
                height: 'auto',
            },
        },
    },
    '& .indexBody': {
        height: '100%',
        '& .listBlock': {
            height: 'calc(100dvh - 155px)',
            overflow: 'auto',
            [theme.breakpoints.down('sm')]: {
                height: 'calc(100dvh - 190px)',
            },
        },
        '& .assetBlock': {
            '& .MuiBox-root': {
                backgroundImage: `url(${assetLoader})`,
                width: '94%',
                height: 'calc(100% - 22px)',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPositionX: 'center',
            },
            '&.rightImgBlock': {
                '& .MuiBox-root': {
                    height: '100%',
                },
            },
        },
    },
    '& .cstNotifyAction': {
        '& .MuiButton-root': {
            boxShadow:
                theme.palette.mode === 'dark'
                    ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
                    : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
            color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
            background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
            fontSize: theme.spacing(1.25),
            fontFamily: 'good_sansbold',
            textTransform: 'capitalize',
        },
    },
}));

export const SliderUI = styled(Slider)(({ theme }) => ({
    marginBottom: `${theme.spacing(0)}`,
    width: '98%',
    '& .MuiSlider-rail,& .MuiSlider-track': {
        opacity: 1,
        background:
            'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
    },
    '& .MuiSlider-markLabel': {
        transform: 'translate(-50%, -51px)',
        fontSize: theme.spacing(1.5),
        '&:nth-child(4)': {
            left: '4% !important',
        },
        '&:nth-child(6)': {
            left: '52% !important',
        },
        '&:nth-child(8)': {
            left: '96% !important',
        },
    },
    '& .MuiSlider-thumb': {
        '&:before': {
            background: 'linear-gradient(320.66deg, #141515 14.75%, #2E3236 84.81%)',
            border: '0.72px solid #282B2E',
            boxShadow: [2],
        },
        '&:after': {
            width: theme.spacing(1),
            height: theme.spacing(1),
            background: 'linear-gradient(320.66deg, #FDCC3F 14.75%, #FF8524  84.81%)',
        },
        transform: 'translate(-8%, -50%)',
    },
}));
